/**
 * Модуль тарифов: период оплаты, карусель, --tariff-rows для subgrid.
 */
function formatNumber(value) {
    return String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

function calcMonthlyPrice(basePrice, percent) {
    return Math.round(basePrice * (1 - percent / 100));
}

function syncTariffRows(root) {
    const table = root.querySelector('.tariffs__table');
    if (!table) {
        return;
    }

    const labels = table.querySelector('.tariffs__labels');
    if (!labels) {
        return;
    }

    const rowsCount = labels.querySelectorAll(':scope > .tariffs__row').length;
    if (rowsCount > 0) {
        table.style.setProperty('--tariff-rows', String(rowsCount));
    }
}

/**
 * Подсветка всей горизонтальной строки в subgrid-таблице
 * (лейбл и ячейки тарифов лежат в разных колонках).
 */
function initRowHover(table) {
    const labels = table.querySelector('.tariffs__labels');
    if (!labels) {
        return;
    }

    const labelRows = Array.from(labels.querySelectorAll(':scope > .tariffs__row'));
    const cols = Array.from(table.querySelectorAll('.tariffs__col'));
    let activeIndex = -1;

    function getColRows(col) {
        return Array.from(col.querySelectorAll(':scope > .tariffs__row'));
    }

    function applyHover(index, isHovered) {
        if (labelRows[index]) {
            labelRows[index].classList.toggle('is-hovered', isHovered);
        }
        cols.forEach((col) => {
            const row = getColRows(col)[index];
            if (row) {
                row.classList.toggle('is-hovered', isHovered);
            }
        });
    }

    function setHovered(index) {
        if (activeIndex === index) {
            return;
        }
        if (activeIndex >= 0) {
            applyHover(activeIndex, false);
        }
        activeIndex = index;
        if (index >= 0) {
            applyHover(index, true);
        }
    }

    function rowIndexFromTarget(target) {
        const row = target.closest('.tariffs__row');
        if (!row || !table.contains(row)) {
            return -1;
        }
        if (row.parentElement === labels) {
            return labelRows.indexOf(row);
        }
        if (row.parentElement && row.parentElement.classList.contains('tariffs__col')) {
            return getColRows(row.parentElement).indexOf(row);
        }
        return -1;
    }

    table.addEventListener('mouseover', (event) => {
        setHovered(rowIndexFromTarget(event.target));
    });
    table.addEventListener('mouseleave', () => {
        setHovered(-1);
    });
}

function initTariffs(root) {
    syncTariffRows(root);

    if (root.dataset.tariffsReady === '1') {
        return;
    }
    root.dataset.tariffsReady = '1';

    const table = root.querySelector('.tariffs__table');
    if (table) {
        initRowHover(table);
    }

    const tabs = Array.from(root.querySelectorAll('.tariffs__tab'));
    const priceParents = Array.from(root.querySelectorAll('[data-price]'));
    const slides = Array.from(root.querySelectorAll('.tariffs__slide'));
    const mobileLimits = Array.from(root.querySelectorAll('.tariffs__mobile-limits'));
    const prevBtn = root.querySelector('.tariffs__nav--prev');
    const nextBtn = root.querySelector('.tariffs__nav--next');

    let activePercent = 0;
    let activeSlide = 0;

    const activeTab = tabs.find((tab) => tab.classList.contains('is-active'));
    if (activeTab) {
        activePercent = Number(activeTab.getAttribute('data-percent')) || 0;
    }

    function updatePrices() {
        priceParents.forEach((parent) => {
            const basePrice = Number(parent.getAttribute('data-price'));
            if (Number.isNaN(basePrice)) {
                return;
            }
            const valueNode = parent.querySelector('.tariffs__price-value');
            if (!valueNode) {
                return;
            }
            valueNode.textContent = formatNumber(calcMonthlyPrice(basePrice, activePercent));
        });
    }

    function setActiveTab(tab) {
        tabs.forEach((item) => {
            const isActive = item === tab;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        activePercent = Number(tab.getAttribute('data-percent')) || 0;
        updatePrices();
    }

    function setActiveSlide(index) {
        if (!slides.length) {
            return;
        }
        const total = slides.length;
        activeSlide = ((index % total) + total) % total;

        slides.forEach((slide, i) => {
            slide.classList.toggle('is-active', i === activeSlide);
        });

        mobileLimits.forEach((block) => {
            const match = Number(block.getAttribute('data-slide-index')) === activeSlide;
            block.classList.toggle('is-active', match);
            if (match) {
                block.removeAttribute('hidden');
            } else {
                block.setAttribute('hidden', '');
            }
        });
    }

    tabs.forEach((tab) => {
        tab.addEventListener('click', () => setActiveTab(tab));
        tab.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                setActiveTab(tab);
            }
        });
    });

    if (prevBtn) {
        prevBtn.addEventListener('click', () => setActiveSlide(activeSlide - 1));
    }
    if (nextBtn) {
        nextBtn.addEventListener('click', () => setActiveSlide(activeSlide + 1));
    }

    const viewport = root.querySelector('.tariffs__viewport');
    if (viewport) {
        let touchStartX = 0;
        viewport.addEventListener('touchstart', (event) => {
            touchStartX = event.changedTouches[0].clientX;
        }, { passive: true });
        viewport.addEventListener('touchend', (event) => {
            const delta = event.changedTouches[0].clientX - touchStartX;
            if (Math.abs(delta) < 40) {
                return;
            }
            setActiveSlide(delta < 0 ? activeSlide + 1 : activeSlide - 1);
        }, { passive: true });
    }

    root.querySelectorAll('.tariffs__discuss').forEach((button) => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            if (typeof Verbox === 'function') {
                Verbox('openSupport');
            }
        });
    });

    updatePrices();
    setActiveSlide(0);
}

function boot() {
    document.querySelectorAll('.tariffs').forEach(initTariffs);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
} else {
    boot();
}
